import Render from "components/Common/Render";
import React from "react";

const ToggleButton: React.FC<{
  onToggle: (e: any) => void;
  value: boolean;
  labelPlacement?: "right" | "left";
  label?: string | React.ReactNode | React.ReactElement;
  disabled?: boolean;
}> = ({ onToggle, value, labelPlacement = "left", label = "", disabled = false }) => {
  return (
    <label className={`inline-flex items-center ${disabled ? 'cursor-not-allowed opacity-60' : 'cursor-pointer'}`}>
      <Render when={labelPlacement === "left"}>
        <span className="ms-3 text-sm font-medium text-gray-900 m-2">
          {label}
        </span>
      </Render>
      <input
        type="checkbox"
        value=""
        className="sr-only peer"
        checked={value}
        onChange={onToggle}
        disabled={disabled}
      />
      <div className="relative w-[32px] h-[16px] bg-gray-200 rounded-full peer peer-checked:after:translate-x-[16px] rtl:peer-checked:after:-translate-x-[16px] peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-[12px] after:w-[12px] after:transition-all peer-checked:bg-[#0102CE]"></div>
      <Render when={labelPlacement === "right"}>
        <span className="ms-3 text-sm font-medium text-gray-900">{label}</span>
      </Render>
    </label>
  );
};

export default ToggleButton;
